import { render, staticRenderFns } from "./archivalrate.vue?vue&type=template&id=1a09fc52&scoped=true&"
import script from "./archivalrate.vue?vue&type=script&lang=js&"
export * from "./archivalrate.vue?vue&type=script&lang=js&"
import style0 from "./archivalrate.vue?vue&type=style&index=0&id=1a09fc52&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a09fc52",
  null
  
)

export default component.exports